import _functionUncurryThis from "../internals/function-uncurry-this";
var exports = {};
var uncurryThis = _functionUncurryThis;
var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1 .toString);
exports = function (key) {
  return "Symbol(" + (key === undefined ? "" : key) + ")_" + toString(++id + postfix, 36);
};
export default exports;